module.exports = __webpack_public_path__ + "img/pn.a7cc83d.svg";